import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {TableCheckBox,DialogSaveButton,AddNewButtonLayout,TableIcon, SearchSpan} from '../../../common/Global/globalStyles.style';
import {getLocalStorageVariables,isEmptyVariable,sortTable,truncateString,
    isEmptyArray,
    hasFeatureAccess,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import SelectDocument from "./selectDocument"
import SelectSampleChecked from "./selectSampleChecked"
import AlertDialog from '../../../common/AlertDialog';
import AddDocument from '../Common/addDocument';
import TableDropDown from '../../../common/DropdownMenus/TableDropdown';
import ReviewHistoryDialog from '../../../common/reviewhistorydialog';
import FilterDropDown from '../../../common/DropdownMenus/FilterDropdown';
import Pagination from '../../../common/Global/pagination';

let userDetails = getLocalStorageVariables();
const sortName = "d.name";
const sortDescription = "d.description";
const departmentFilterDropdownDefaultValue = "All";
const activeStatus="Active";
class DocumentSampleList extends Component{
    constructor(props){
        super(props);
        this.state = {
            componentDidMountFlag:false,
            datalist:[],
            currentPageNo: 1,
            searchkey:"",
            resultSize:Constants.RESULT_SIZE,
            status:activeStatus,
            sort:"",
            sortDir:"",
            apiSearchKey:"",
            showLoader:false,
            totalCount:0,
            resultSizePlaceholder:Constants.RESULT_SIZE,
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            selectedId:"",
            deptOnly:"N",
            docTypes:[],
            showCreateDialog:false,
            isEdit:false,
            showDocumentsListDialog:false,
            showSampleCheckedListDialog:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            showReviewHistoryDialog:false,
            deleteReactivateId:"",
            operationType:"",
            alertDialogHeading:"",
            proceedBtnLabel:"",
            showAlertDialog:false,
            alertDialogMessage:"",
            selectedItem:{},
            selectedDocumentMap:{},
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showDocumentDialog){
            this.setState({
                componentDidMountFlag:true,
                datalist:[],
                currentPageNo: 1,
                searchkey:"",
                resultSize:Constants.RESULT_SIZE,
                sort:"",
                sortDir:"",
                apiSearchKey:"",
                totalCount:0,
                resultSizePlaceholder:Constants.RESULT_SIZE,
                resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
                selectedId:"",
                deptOnly:"N",
                showLoader:false,
                docTypes:[],
                showCreateDialog:false,
                isEdit:false,
                showDocumentsListDialog:false,
                showSampleCheckedListDialog:false,
                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
                showReviewHistoryDialog:false,
                deleteReactivateId:"",
                selectedItem:{},
                selectedDocumentMap:{},
            },()=>{
                if(!hasFeatureAccess(Constants.FEATURE_DOCUMENT)){
                    this.getInitData();
                }
            })
            
        }
    }

    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getDocumentMasterList();
        })
    }

    handleChangeSearch = (e) => {
        const { name, value } = e.target;

        this.setState({ 
            [name]: value
        });
    }

    onSearchIconClick = () => {
        this.setState({
            currentPageNo:1
        },()=>{
            this.getDocumentMasterList();
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.setState({
                currentPageNo:1
            },()=>{
                this.getDocumentMasterList();
            })
        }
    }

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getDocumentMasterList();
        })
    }

    showSampleCheckedListDialog = () => {
        this.setState({
            showSampleCheckedListDialog:true
        })
    }

    closeSampleCheckedListDialog = () => {
        this.setState({
            showSampleCheckedListDialog:false
        })
    }
    SampleCheckedListDialogSaveClose = (arr) => {
        this.setState({
            showSampleCheckedListDialog:false,
            datalist:[...this.state.datalist,...arr]
        })
    }
    showDocumentListDialog = () => {
        this.setState({
            showDocumentsListDialog:true
        })
    }

    closeDocumentListDialog = () => {
        this.setState({
            showDocumentsListDialog:false
        })
    }

    documentListDialogSaveClose = (arr) => {
        this.setState({
            showDocumentsListDialog:false,
            datalist:[...this.state.datalist,...arr]
        });
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    deleteSelectedDocument = (index) => {
        let datalist = this.state.datalist;

        datalist.splice(index,1)

        this.setState({
            datalist:datalist
        })
    }

    
    handleBlurSizeValue = (index, e) => {
        const value = e.currentTarget.textContent;
		let datalistTemp = this.state.datalist;

		if (datalistTemp[index].description + "" !== value) {
            datalistTemp[index].description = value;
            this.setState({
                datalist: datalistTemp,
            });
		}
	};

    handleSelection = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let index = e.target.name;
        let selectedDocArrTemp = this.state.selectedDocumentMap;

        let datalistTemp = [...this.state.datalist];
        datalistTemp[index] = { ...datalistTemp[index], isSelected: isChecked };
        if(isChecked){
            selectedDocArrTemp[datalistTemp[index].documentId] = datalistTemp[index];
        }else{
            delete selectedDocArrTemp[datalistTemp[index].documentId]
        }

        this.setState({
            datalist:datalistTemp,
            selectedDocumentMap:selectedDocArrTemp
        });
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    addDocumentDialog = () => {
        this.setState({
            showCreateDialog:true
        });
    }

    handleCreateDialogClose = (reloadFlag) =>{
        this.setState({
            showCreateDialog:false
        },() => {
            if(reloadFlag == true){
                this.getDocumentMasterList();
            }
        });
    }

    handleAlertDialogClose = () =>{
        this.setState({
            showAlertDialog:false,
            alertDialogMessage:""
        });
    }

    handleReviewHistoryDialogClose = () =>{
        this.setState({
            showReviewHistoryDialog:false,
            deleteReactivateId:"",
        });
    }

    onTableDropDownItemClick = (item, dropdownItem) => {
        if(item.label === "Delete"){
            this.setState({
                operationType:item.label,
                alertDialogHeading:"Delete Master",
                proceedBtnLabel:"Delete",
                deleteReactivateId:dropdownItem.documentId,
                showAlertDialog:true,
                alertDialogMessage:"Are you sure you want to delete master "+dropdownItem.name+"?"
            })
        }else if(item.label === "Edit"){
            this.setState({
                showCreateDialog:true,
                isEdit:true,
                selectedId:dropdownItem.documentId,
                selectedItem:dropdownItem
            });
        }else if(item.label === "Review History"){
            this.setState({
                deleteReactivateId:dropdownItem.documentId,
                showReviewHistoryDialog:true,
            })
        }
    }
    /*****************************API CALL*********************************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetDocumentMasterCreateMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    sourcePage:'Working Paper'
                })
            }),
            fetch(Constants.GetDocumentMaster,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:this.state.currentPageNo,
                    search:this.state.searchkey,
                    resultsize:this.state.resultSize,
                    status_new:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentOnly:this.state.deptOnly,
                    sourcePage:'Working Paper'
                })
            })
        ])
        .then(([masterRes,generalRes]) => { 
            return Promise.all([masterRes.json(),generalRes.json()]) 
        })
        .then(([masterRes,generalRes]) => {
            let datalistTemp = [];
            let totalCountTemp = 0;
            let deptTemp = [];
            let docTypes = [];

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                    deptTemp = masterRes.data.departments.sort((a, b) => a.name.localeCompare(b.name));
                    docTypes = masterRes.data.documentTypes;
            }else{
                deptTemp = [];
            }

            if(handleTokenExpiry(generalRes.responseCode)) return;
            else if(generalRes.responseCode === Constants.CODE_SUCCESS){
                datalistTemp = generalRes.data.result;
                totalCountTemp = generalRes.data.count;
                datalistTemp.map((item,idx)=>{
                    if(!isEmptyVariable(this.state.selectedDocumentMap[item.documentId])){
                        datalistTemp[idx].isSelected=true;
                    }
                })
                
            }else{
                datalistTemp = [];
            }

            //Filter Dept array
            let filterDeptArr = [];
            let selectedFilterDepartmentId = "-100";
            let selectedFilterDepartmentName = "All";
            if(!isEmptyArray(deptTemp) && deptTemp.length===1){

            }else{
                let obj = {
                    departmentId:"-100",
                    name:departmentFilterDropdownDefaultValue,
                    isSelected:true
                }
                filterDeptArr = [...deptTemp];
                filterDeptArr.splice(0,0,obj)
            }

            this.setState({
                componentDidMountFlag:true,
                showLoader:false,

                datalist:datalistTemp,
                totalCount:totalCountTemp,
                departmentArr:deptTemp,

                docTypes:docTypes,


                filterDeptArr:filterDeptArr,
                selectedFilterDepartmentId:selectedFilterDepartmentId,
                selectedFilterDepartmentName:selectedFilterDepartmentName,
            })
        })
    }

    getDocumentMasterList = () => {
        this.setState({
            showLoader:true,
        });

        let postParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            pageNo:this.state.currentPageNo,
            search:this.state.searchkey,
            resultsize:this.state.resultSize,
            status_new:this.state.status,
            sort:this.state.sort,
            sortDir:this.state.sortDir,
            sourcePage:'Working Paper'
        }

        if(this.state.filterDeptArr.length > 1 &&
            this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue){
            postParam.departmentId = this.state.selectedFilterDepartmentId;
        }

        fetch(Constants.GetDocumentMaster,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams(postParam)
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    datalist:data.data.result,
                    totalCount:data.data.count,
                    apiSearchKey:this.state.searchkey,
                });
                let datalistTemp = data.data.result;
                datalistTemp.map((item,idx)=>{
                    if(!isEmptyVariable(this.state.selectedDocumentMap[item.documentId])){
                        datalistTemp[idx].isSelected=true;
                    }
                })
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                    totalCount:0,
                    componentDidMountFlag:true,
                    apiSearchKey:this.state.searchkey,
                });
            }
        });
    }

    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
    
            fetch(Constants.GetDocumentMaster,
            {
                method:"POST",
                mode:"cors",
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:page,
                    search:this.state.searchkey,
                    status:activeStatus,
                    resultsize:this.state.resultSize,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentId:this.props.departmentId,
                    activeFlag:"Y",
                    sourcePage:'Working Paper'
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let dataList = data.data.result
                    dataList.map((item,idx)=>{
                        if(!isEmptyVariable(this.state.selectedDocumentMap[item.documentId])){
                            dataList[idx].isSelected=true;
                        }
                    })
    
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:dataList,
                        totalCount:data.data.count,
                        apiSearchKey:this.state.searchkey,
                        currentPageNo:page,
                    });
                }else{
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:[],
                        totalCount:0,
                        apiSearchKey:this.state.searchkey,
                    });
                }
            });
        }
    }

    addNewWorkingPaper = () => {
        this.setState({
            showLoader:true
        })
        let isError = false;
        if(isEmptyArray(this.state.datalist)){
            isError = true;
        }

        const list = this.state.datalist.filter(item => item.isSelected === true);
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please select atleast one document"
            })
        }else{
            fetch(Constants.AddNewWorkingPaper, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.props.assignmentId,
                    documents: JSON.stringify(this.state.datalist),
                }),
            })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if (data.responseCode === Constants.CODE_SUCCESS) {
                    this.setState({
                        showLoader:true
                    })
                    this.props.handleSelectDocDialogSaveClose(true);
                } else {
                }
            });
        }
    }

    handleRecordOperation = () => {
        let url = "";
        let postParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            documentId:this.state.deleteReactivateId,
            sourcePage:'Working Paper'
        }
        let callApi = true;

        if(this.state.operationType === "Delete"){
            url = Constants.DeleteDocumentMaster;
        }

        if(callApi){
            this.setState({
                showBtnLoader:true,
            });

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        deleteReactivateId:"",
                        operationType:"",
                        alertDialogHeading:"",
                        proceedBtnLabel:"",
                        alertDialogMessage:"",
                        actionType:"",
                        showAlertDialog:false,
                        showBtnLoader:false,
                    },() => {
                        this.getDocumentMasterList();
                    });
                }else{
                    this.setState({
                        showBtnLoader:false,
                        deleteReactivateId:"",
                        operationType:"",
                        actionType:"",
                        alertDialogHeading:"",
                        proceedBtnLabel:"",
                        alertDialogMessage:"",
                        showAlertDialog:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                    })
                }
            });
        }
    }
    /*****************************API CALL END HERE*********************************/
    
    render(){
         const actionArr = [
            {
                icon:"edit",
                label:"Edit"
            },
            {
                icon:"delete",
                label:"Delete"
            },
            {
                icon: "history",
                label: "Review History"
            }
        ]
        return(
            <section>
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.props.showDocumentDialog} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>Get Documents</h5>
                        <button 
                            onClick={this.props.handleSelectDocDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        {
                            // Need to check component did mount flag, other wise until api is called,
                            // it shows no items found layout.
                            this.state.componentDidMountFlag &&
                            <div className="body-wrapper">
                                <div className="search-addnew-bg" style={{marginTop:0}}>
                                    <div className="search-addnew">
                                        <div className="search-filter-layout" style={{position:"relative"}}>
                                            <FilterDropDown
                                                placeholder={this.state.resultSizePlaceholder}
                                                dropdownArr={this.state.resultSizeArr}
                                                onDropDownItemClick={this.resultSizeDropdownClick}
                                                addBorder={true}
                                                themeSettings={this.props.themeSettings}
                                                mleft={0}   
                                            />
                                            <div className="search-col m-l-10" style={{border:"1px solid #e5e5e5"}}>
                                                <input 
                                                    name="searchkey" 
                                                    type="text"
                                                    onChange={this.handleChangeSearch}
                                                    placeholder="Search" 
                                                    onKeyPress={this.onEnterBtnPress}
                                                    value={this.state.searchkey}
                                                />
                                                <SearchSpan
                                                themeSettings={this.props.themeSettings}
                                                onClick = {this.onSearchIconClick} className="material-icons"> search </SearchSpan>
                                            </div>  
                                            {/* <div className="overlay-nr" style={{display:this.state.document_NR === "Y"?"block":"none"}}></div> */}
                                        </div>
                                        <div className="flex-center-layout">
                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT) && 
                                            hasFeatureAccess(Constants.FEATURE_EXECUTE_SAMPLE_CHECKED) &&
                                                <AddNewButtonLayout style={{marginRight:10}}themeSettings={this.props.themeSettings}>
                                                    <a onClick={this.showSampleCheckedListDialog} href="javascript:void(0);">
                                                        <span className="material-icons">add_circle</span>
                                                        <p>Doc List</p>
                                                    </a>
                                                </AddNewButtonLayout>
                                            }
                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                <AddNewButtonLayout themeSettings={this.props.themeSettings}>
                                                    <a onClick={this.showDocumentListDialog} href="javascript:void(0);">
                                                        <span className="material-icons">add_circle</span>
                                                        <p>Documents Master</p>
                                                    </a>
                                                </AddNewButtonLayout>
                                            }
                                            {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                <AddNewButtonLayout style={{marginRight:10}}themeSettings={this.props.themeSettings}>
                                                    <a onClick={this.addDocumentDialog} href="javascript:void(0);">
                                                        <span className="material-icons">add_circle</span>
                                                        <p>Add New</p>
                                                    </a>
                                                </AddNewButtonLayout>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div style={{position:"relative"}}>
                                    {
                                        !isEmptyArray(this.state.datalist) && 
                                        <div className="common-tab-bg">
                                            <div className="common-table" style={{width:"100%",border:"1px solid #e5e5e5"}}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                <th className="text-center" width={"8%"}></th>
                                                            }
                                                            <th className="text-center" width={"5%"}>No.</th>
                                                            <th className="c-pointer" width={"25%"} onClick={this.sortTableLocal.bind(this,sortName)}>
                                                                <div className="sort-header">Name
                                                                    <span className={(this.state.sort === sortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th> 
                                                            <th width={"12%"}>Type</th>
                                                            {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                <th className="c-pointer" width={"25px"} onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                                    <div className="sort-header">Description
                                                                        <span className={(this.state.sort === sortDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                    </div>
                                                                </th>
                                                            }
                                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                <th width={"320px"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                                {
                                                                    this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING 
                                                                    ?
                                                                    <div className="flex-center-layout table-cell-edit"><p>Description</p><span className="material-icons">edit</span></div>
                                                                    :
                                                                    <div>Description</div>

                                                                }
                                                                </th>
                                                            }
                                                            {!isEmptyArray(this.state.departmentArr) && this.state.departmentArr.length > 1 && 
                                                                <th width={"25%"}>Department</th>
                                                            }
                                                            {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                <th width={"3%"}></th>
                                                            }
                                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                <th className="text-center" width={"10%"}>Delete</th>
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        !isEmptyArray(this.state.datalist) && 
                                                        this.state.datalist.map((item,idx) => {
                                                            return <tr>
                                                                {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                    <td>
                                                                        <TableCheckBox onClick={this.handleStopPropagation}
                                                                            themeSettings={this.props.themeSettings}>
                                                                            <input 
                                                                                type="checkbox"
                                                                                name={idx}
                                                                                id={item.documentId}
                                                                                onChange={this.handleSelection}
                                                                                checked={item.isSelected?true:false}
                                                                            />
                                                                            <label for={item.documentId} 
                                                                            style={{marginLeft:6}}></label>
                                                                        </TableCheckBox>
                                                                    </td>
                                                                }
                                                                <td className="text-center">{(idx+1)}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.documentType}</td>
                                                                {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                    <td>{item.description}</td>
                                                                }
                                                                {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                    <td>
                                                                        <div contentEditable="true" className="single-line-editable" spellCheck="true" 
                                                                        onBlur={this.handleBlurSizeValue.bind(this, idx)}>
                                                                            {item.description}
                                                                        </div>
                                                                    </td>
                                                                }
                                                                {!isEmptyArray(this.state.departmentArr) && this.state.departmentArr.length > 1 && 
                                                                    <td>{item.departmentName}</td>
                                                                }
                                                                {!hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                    <td className="text-center">
                                                                        <TableDropDown
                                                                            actionArr={actionArr}
                                                                            onDropDownItemClick={this.onTableDropDownItemClick}
                                                                            dropDownId={item}
                                                                            dropdownWidth={"160px"}
                                                                            themeSettings={this.props.themeSettings}
                                                                        />
                                                                    </td>
                                                                }
                                                                {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                                                    <TableIcon 
                                                                        onClick={this.deleteSelectedDocument.bind(this,idx)}
                                                                        themeSettings={this.props.themeSettings} className="text-center">
                                                                        <span class="material-icons">delete</span>
                                                                    </TableIcon>
                                                                }
                                                            </tr>
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                    {
                                        this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) &&
                                        <div class="no-items-layout">
                                            <div class="no-items-card">
                                                <h6>Please add documents</h6>
                                            </div>
                                        </div>
                                    }
                                    <div className="pagination-layout">
                                        <div className="row custom-row">
                                            <div className="col-md-9 custom-col">
                                            {
                                                (this.state.totalCount > this.state.datalist.length) && 
                                                <Pagination
                                                    totalLength ={this.state.totalCount} 
                                                    items={this.state.datalist} 
                                                    onChangePage={this.onChangePage} 
                                                    pageSize={this.state.resultSize}
                                                    currentPageNo = {this.state.currentPageNo}
                                                    initialPage={this.state.currentPageNo}
                                                    themeSettings={this.props.themeSettings} />
                                            }
                                            </div>
                                            <div className="col-md-3 custom-col">
                                                <p>{"Total Records: "+this.state.totalCount}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* {
                                    !isEmptyVariable(this.state.documentFormErr) &&
                                    <span className="cm-error">{this.state.documentFormErr}</span>
                                } */}
                                <div className="modal-close-save m-t-15">
                                    <div className="close-save-col">
                                        <button onClick={this.props.handleSelectDocDialogClose} type="button" 
                                        className="modal-close m-b-0">Cancel</button>
                                        <DialogSaveButton  themeSettings={this.props.themeSettings} 
                                        onClick={this.addNewWorkingPaper} type="button" 
                                        className="modal-save m-b-0">Save</DialogSaveButton>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal>

                <SelectSampleChecked
                    showDocumentDialog = {this.state.showSampleCheckedListDialog}
                    handleSelectDocDialogClose = {this.closeSampleCheckedListDialog}
                    handleSelectDocDialogSaveClose = {this.SampleCheckedListDialogSaveClose}
                    themeSettings={this.props.themeSettings}
                    departmentId={this.props.departmentId}
                    assignmentId={ this.props.assignmentId}
                    subscriptionType={this.props.subscriptionType}
                />
                <SelectDocument
                    showDocumentDialog = {this.state.showDocumentsListDialog}
                    handleSelectDocDialogClose = {this.closeDocumentListDialog}
                    handleSelectDocDialogSaveClose = {this.documentListDialogSaveClose}
                    themeSettings={this.props.themeSettings}
                    departmentId={this.props.departmentId}
                    subscriptionType={this.props.subscriptionType}
                />
                <AddDocument
                    showCreateDialog={this.state.showCreateDialog}
                    isEdit={this.state.isEdit}
                    handleCreateDialogClose={this.handleCreateDialogClose}
                    departmentArr={this.state.departmentArr}
                    docTypes={this.state.docTypes}
                    selectedId={this.state.selectedId}
                    sourcePage={'Working Paper'}
                    selectedItem={this.state.selectedItem}
                    themeSettings={this.props.themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={this.state.alertDialogHeading}
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={this.handleRecordOperation}
                    proceedBtnLabel={this.state.proceedBtnLabel}
                    showLoader={this.state.showBtnLoader}
                    themeSettings={this.props.themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />

                <ReviewHistoryDialog
                    showReviewHistoryDialog={this.state.showReviewHistoryDialog}
                    handleReviewHistoryDialogClose={this.handleReviewHistoryDialogClose}
                    masterType={"Document"}
                    masterDataId={this.state.deleteReactivateId}
                />
            </section>
        )
    }
}

export default DocumentSampleList;